var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTwitter(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1858_3605)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 12.5004,
    cy: 12.5,
    rx: 12.5004,
    ry: 12.5,
    fill: "#55ACEE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.5006 9.12299C18.9763 9.34526 18.4203 9.49115 17.8509 9.55583C18.444 9.21563 18.8994 8.6769 19.1138 8.03502C18.55 8.35522 17.9331 8.58082 17.2899 8.70208C16.7659 8.16785 16.0194 7.83398 15.1932 7.83398C13.6069 7.83398 12.3208 9.06479 12.3208 10.5828C12.3208 10.7983 12.3462 11.0081 12.3952 11.2093C10.008 11.0946 7.89152 10.0003 6.4748 8.33717C6.2276 8.74316 6.08596 9.21542 6.08596 9.71913C6.08596 10.6728 6.59309 11.5142 7.36377 12.0072C6.90764 11.9935 6.46154 11.8756 6.06272 11.6633C6.06255 11.6748 6.06255 11.6863 6.06255 11.6979C6.06255 13.0298 7.05264 14.1408 8.36661 14.3934C7.94363 14.5034 7.49996 14.5196 7.06949 14.4405C7.43498 15.5326 8.49578 16.3273 9.75265 16.3495C8.76961 17.0868 7.53106 17.5263 6.18538 17.5263C5.9535 17.5263 5.7249 17.5132 5.50018 17.4878C6.77132 18.2678 8.28113 18.7229 9.90321 18.7229C15.1866 18.7229 18.0756 14.5341 18.0756 10.9016C18.0756 10.7824 18.0729 10.6638 18.0673 10.546C18.6296 10.1569 19.115 9.67506 19.5006 9.12299Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1858_3605"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 25.0008,
    height: 25,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTwitter);
export default __webpack_public_path__ + "static/media/twitter.54d04e6f37245020dbb986babebf0ad2.svg";
export { ForwardRef as ReactComponent };